import { Suspense, lazy } from 'react';

// Project imports
import Loader from './Loader';
import { isChunkLoadError, reloadOnceOnChunkError } from '../reloadOnChunkError';

// Функція для штучної затримки
const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

// Оновлена функція Loadable
const Loadable = (importFunc, showLoader = true, delayMs = 0) => {
    const LazyComponent = lazy(async () => {
        await delay(delayMs);
        try {
            return await importFunc();
        } catch (error) {
            if (isChunkLoadError(error)) reloadOnceOnChunkError();
            throw error;
        }
    });

    return (props) => (
         
        <Suspense fallback={showLoader && (<Loader />)}> 
            <LazyComponent {...props} />
        </Suspense>
    );
};

export default Loadable;
